import { isIEditorV3 } from "@azu-business/editor-v3";
import { ARS, ArsTableGroupCalculationDto, isArsListingBody, isArsTableBody } from "aic";
import { TlfItemReadDtoContext } from "contexts/tlf/interface";
import { eTlfItemType } from "functions/api/enums";
import { TitlesFootnotesReadDto } from "functions/api/tlfItem/TitlesFootnotesReadDto";

/**
 * Recursive function to get case when conditions from an ArsTableCalculationDto and its subgroups
 *
 * @param group - any ArsTableCalculationDto
 * @returns Add caseWhenConditions in this group and its subgroups
 */
const getCaseWhenFromArsTableGroup = <T>(
  group: ArsTableGroupCalculationDto<T>,
): ARS.CaseWhenCondition<T>[] => {
  const ret: ARS.CaseWhenCondition<T>[] = [];
  if ("caseWhenCondition" in group && group.caseWhenCondition) {
    ret.push(group.caseWhenCondition);
  }
  ret.push(...(group.subGroups?.flatMap(getCaseWhenFromArsTableGroup) ?? []));
  return ret;
};

/**
 * Get the case when conditions from the TLF data item in the context
 *
 * @param tlfData - TLF data item
 * @returns Array of case when conditions
 */
export const getCaseWhenConditionsFromTlf = <T>(
  tlfData?: TlfItemReadDtoContext | TitlesFootnotesReadDto,
): ARS.CaseWhenCondition<T>[] => {
  const ret = [];
  if (tlfData?.type === eTlfItemType.arsListing && isArsListingBody(tlfData.body, isIEditorV3)) {
    ret.push(
      ...(tlfData.body.arsListingColumns
        .map((column) => column.caseWhenCondition)
        .filter(Boolean) as ARS.CaseWhenCondition<T>[]),
    );
  } else if (tlfData?.type === eTlfItemType.arsTable && isArsTableBody(tlfData.body, isIEditorV3)) {
    ret.push(
      ...([
        ...tlfData.body.columns.flatMap(getCaseWhenFromArsTableGroup),
        ...tlfData.body.rows.flatMap(getCaseWhenFromArsTableGroup),
      ].filter(Boolean) as ARS.CaseWhenCondition<T>[]),
    );
  }
  return ret;
};
